import React, { useMemo } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import HealthIndexMetric from './HealthIndexMetric';
import CapacityMetric from './CapacityMetric';

export interface StorageHealthData {
    storageId: string;
    storageName: string;
    healthIndex: number | null;
    capacity: number | null;
}

interface OverallDashboardProps {
    storageData: StorageHealthData[];
    onStorageSelect?: (storageId: string) => void;
}

const OverallDashboard: React.FC<OverallDashboardProps> = ({ storageData, onStorageSelect }) => {
    // Prepare data for HealthIndexMetric
    const healthData = useMemo(() => {
        return storageData.map(storage => ({
            storageId: storage.storageId,
            storageName: storage.storageName,
            healthIndex: storage.healthIndex
        }));
    }, [storageData]);

    // Prepare data for CapacityMetric
    const capacityData = useMemo(() => {
        return storageData.map(storage => ({
            storageId: storage.storageId,
            storageName: storage.storageName,
            capacity: storage.capacity
        }));
    }, [storageData]);

    return (
        <Card>
            <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ mb: 1 }}>
                    Overall Metrics
                </Typography>
                
                <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={1.5}>
                    <HealthIndexMetric 
                        storageData={healthData}
                        onStorageSelect={onStorageSelect}
                    />
                    <CapacityMetric 
                        storageData={capacityData}
                        onStorageSelect={onStorageSelect}
                    />
                </Box>
            </CardContent>
        </Card>
    );
};

export default OverallDashboard;
